<!-- Contains the options in the layout toolbar, such as saving the current layout -->
<template>
  <div class="layout-options-main">
    <span class="mx-2 font-weight-bold">
      {{ t('reportingPage.sections.product.sideBar.toolPanels.layouts.currentLayout') }}
      {{ props.selectedLayoutName }}
    </span>
    <v-btn
      id="btnSave"
      class="mx-2"
      primary
      variant="flat"
      width="min-content"
      height="18"
      @click="save"
    >
      {{ t('actions.save') }}
    </v-btn>

    <v-dialog v-model="isModalOpen" content-class="rtls-dialog" :width="500">
      <BaseDialogCard
        :title="t('reportingPage.sections.product.sideBar.toolPanels.layouts.saveLayout')"
        @close="close"
      >
        <v-container fluid class="pa-0">
          <div class="mt-4">
            <v-row>
              <span class="font-weight-bold">
                {{ t('reportingPage.sections.product.sideBar.toolPanels.layouts.layoutName') }}
              </span>
            </v-row>
            <v-row>
              <v-text-field v-model="layoutName" class="mr-2 ml-4 my-2" hide-details />
            </v-row>
          </div>
        </v-container>
        <template #footer>
          <div class="d-flex justify-end pa-0">
            <v-btn id="btnSaveLayout" action :disabled="!layoutName" @click="saveLayout">
              {{ t('actions.save') }}
            </v-btn>
          </div>
        </template>
      </BaseDialogCard>
    </v-dialog>
  </div>
</template>

<script setup>
import { ref, nextTick } from 'vue';
import { useInternationalization } from '@/composables/use-internationalization';

const { t } = useInternationalization();

const props = defineProps({
  selectedLayoutName: {
    type: String,
    required: true,
  },
});
const isModalOpen = ref(false);
const emit = defineEmits(['save']);
const layoutName = ref('');

const save = () => {
  isModalOpen.value = true;
};
const close = () => {
  isModalOpen.value = false;
};
const saveLayout = () => {
  emit('save', {
    name: layoutName.value,
    saveLayout: save,
    closeModal: close,
  });
  close();
  nextTick(() => {
    layoutName.value = '';
  });
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.layout-options-main {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  margin-top: 5px;
  width: 100%;
}
</style>
